// extracted by mini-css-extract-plugin
module.exports = {"FormButton":"FormButton_FormButton__3CkH5","isDisabled":"FormButton_isDisabled__ILl_A","isTransparent":"FormButton_isTransparent__2mNaI"};